import React, { useState, useEffect } from "react";
import Header from "../../components/Header";
import { useNavigate } from "react-router-dom";
import { makeAuthenticatedGet } from "../../utils/fetchUtils";
import { GET_SAVED_BOOKS, GET_USER_INFO } from "../../utils/constants";
import { ISavedBook, IUser } from "../../utils/types";
import SideBar from "../../components/Sidebar";
import useWindowWidth from "../../utils/windowWidth";

const BookShelf = () => {
  const navigate = useNavigate();
  const [savedBooks, setSavedBooks] = useState<ISavedBook[]>([]);
  const [message, setMessage] = useState("");
  const [userDetails, setUserDetails] = useState<IUser | null>(null);

  useEffect(() => {
    if (
      localStorage.getItem("token") === null ||
      localStorage.getItem("token") === undefined
    ) {
      navigate("/login");
    }
    document.title = "BookShelf - Nclude Portal";
    fetchSavedBooks();
    fetchUserDetails();
  }, []);

  const fetchUserDetails = async () => {
    try {
      const resp = await makeAuthenticatedGet(GET_USER_INFO);
      console.log(resp);
      if (resp.success) {
        setUserDetails(resp.user);
        // console.log(userDetails);
      }
    } catch (error) {}
  };

  const fetchSavedBooks = async () => {
    try {
      const resp = await makeAuthenticatedGet(GET_SAVED_BOOKS);
      console.log(resp);
      if (resp.success === true) {
        setSavedBooks(resp.books);
      } else {
        setMessage(resp.message);
      }
    } catch (error: any) {
      if (error.response && error.response.data) {
        // console.log(error.response.data.message)
        setMessage(error.response.data.message);
      }
      // console.log(error);
    }
  };

  const handleViewBtn = async (bookUrl: string) => {
    // console.log(bookUrl);
    try {
      window.open(bookUrl, "_blank");
    } catch (error) {}
  };

  //window size
  const windowWidth = useWindowWidth();
  const isMobile = windowWidth < 769;

  return (
    <>
      {/* <h2 className="display-6">{"Bookshelf"}</h2> */}
      <div className="component-container profile-container">
        <div className="flex ">
          {/* <h4 className="text-3xl">BookShelf</h4> */}
        </div>
        <ul className=" md:w-[60%]  bookshelf-list">
          {savedBooks.map((book, index) => (
            <li
            key={index}
            className="border-2 border-white bg-white px-6 rounded items-center text-center bookshelf-book"
          >
            <div style={{ textAlign: "left" }}>
              <p className="my-2" style={{ fontSize: isMobile ? "2.5rem" : undefined }}>
                {book.bookName}
              </p>
              <p className="my-2" style={{ color: "#787486" }}>{book.bookFormat}</p>
            </div>
            <button
              className="bg-[#5030E5]"
              style={{
                width: isMobile ? "100px" : "6.25rem",
                height: isMobile ? "5rem" : "1.875rem",
                color: "white",
                borderRadius: "8px",
                fontSize: isMobile ? "2rem" : undefined,
              }}
              onClick={() => handleViewBtn(book.bookUrl)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  handleViewBtn(book.bookUrl);
                }
              }}
              aria-label={`View ${book.bookName} in ${book.bookFormat} format`}
            >
              View
            </button>
          </li>
          
          ))}
        </ul>
      </div>
    </>
    // <div className="px-12">
    //   {!isMobile && <Header />}
    //   <div className="page-container">
    //     <SideBar activePage="BookShelf"/>
    //     <div className="mt-12 doc-container" role="main">

    //     </div>
    //   </div>
    // </div>
  );
};

export default BookShelf;
